import privacyNotice from '../regulatoryDisclosureDocs/privacyNotice.pdf'
import PrivacyContent from './PrivacyContent.tsx'
export default function Privacy({ style }) {
  return (
    <div style={style}>
      <div class="text-document container">
        <p style={{ textAlign: 'left' }}><strong style={{ fontSize: "10px" }}>
          <a href={privacyNotice} target='_blank'>Open PDF</a></strong>
        </p>
        <PrivacyContent />
      </div >
    </div >
  );
}